import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { AiOutlineClose } from "react-icons/ai";

const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.5 },
};

const modalVariants = {
    hidden: { opacity: 0, y: "-30px" },
    visible: { opacity: 1, y: "0px", transition: { duration: 0.3 } },
    exit: { opacity: 0, y: "-30px", transition: { duration: 0.2 } },
};
interface request {
    isOpen: boolean,
    onClose: () => void,
    title: string,
    body: any,
    modal: boolean
}
export default function Popup({
    isOpen,
    onClose,
    title = "Modal Title",
    body = null,
    modal = true,
}: request) {
    return (
        <AnimatePresence>
            {isOpen && (
                <>
                    {modal && (
                        <motion.div
                            className="modal-backdrop show"
                            style={{ zIndex: 1040 }}
                            variants={backdropVariants}
                            initial="hidden"
                            animate="visible"
                            exit="hidden"
                        />
                    )}
                    <motion.div
                        className="modal d-block"
                        style={{ zIndex: 1050 }}
                        variants={modalVariants}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content shadow">
                                <div className="modal-header d-flex justify-content-between align-items-center">
                                    <h5 className="modal-title m-0">{title}</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={onClose}
                                        aria-label="Close"
                                        style={{ border: "none", background: "none" }}
                                    >
                                        <AiOutlineClose size={20} />
                                    </button>
                                </div>
                                <div className="modal-body">{body}</div>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
